<template>
  <tbody class="user-order-list">
    <tr class="user-order-item">
      <!-- <tr class="title">
      <td>组合商品单号：{{ product.group_product_id }}</td>
      <td></td>
      <td></td>
      <td></td>
    </tr> -->
      <td class="user-order-name">
        <el-row>
          <el-col :span="4">
            <img
              alt="商品图片"
              :src="image(product)"
              @click="gotoProduct(product.product_id)"
            />
          </el-col>
          <el-col :span="16" class="user-order-product-title">
            <div @click.stop="gotoProduct(product.product_id)">
              {{ product.name }}
            </div>
            <div class="type">{{ product.option_values }}</div>
            <div class="sku">SKU：{{ decodeURIComponent(product.sku) }}</div>
          </el-col>
          <el-col :span="2" class="user-order-product-operate">
            <div>
              <el-button
                @click="getDeliveryInfo(product)"
                v-show="
                  orderInfo.shipping_display === true &&
                    product.shipping_display === true &&
                    orderInfo.type !== 5
                "
                >查看物流</el-button
              >
            </div>
            <div>
              <el-button
                @click="askServe(product, product.supplier)"
                v-show="
                  orderInfo.complaint_display === true && orderInfo.type !== 5
                "
                >申请售后</el-button
              >
            </div>
          </el-col>
        </el-row>
      </td>
      <td>X {{ product.quantity }}</td>
      <td class="red_word">
        <div v-if="orderInfo.order_total.coupon === '0.00'">
          {{ product.price | jifen }}
        </div>
        <div v-else>
          <div class="after-price">
            券后价：
            <span class="price">{{ product.price | jifen }}</span>
          </div>
          <div class="before-price">
            券前价：
            {{ product.price_before_coupon | jifen }}
          </div>
        </div>
      </td>
      <td class="user-order-operation red_word">
        {{ product.total | jifen }}
        <div class="refund fx-row" v-if="product.is_refund">
          <div v-if="Number(product.refunded_credit)">
            退余额
            {{ product.refunded_credit | jifen }}
          </div>
          <div class="user-paid" v-if="Number(product.refunded_user_paid)">
            退自费
            {{ product.refunded_user_paid | jifen }}
          </div>
        </div>
      </td>
    </tr>
    <!-- <tr
      class="user-order-item group"
      v-show="product.group_product_id"
      v-for="group in product.groups"
      :key="group.id"
    >
      <td class="user-order-name">
        <el-row>
          <el-col :span="4">
            <img
              alt="商品图片"
              :src="group.product_image ? group.product_image : goodsDefault"
              @click="gotoProduct(group.product_id)"
            />
          </el-col>
          <el-col
            :span="16"
            class="user-order-product-title"
            @click.stop="gotoProduct(group.product_id)"
            >{{ group.name }}</el-col
          >
          <el-col :span="2" class="user-order-product-operate">
            <div>
              <el-button
                @click="getDeliveryInfo(product)"
                v-show="
                  orderInfo.shipping_display === true &&
                    group.shipping_display === true &&
                    orderInfo.type !== 5
                "
                >查看物流</el-button
              >
            </div>
            <div>
              <el-button
                @click="askServe(group, group.supplier)"
                v-show="
                  orderInfo.complaint_display == true && orderInfo.type !== 5
                "
                >申请售后</el-button
              >
            </div>
          </el-col>
        </el-row>
      </td>
      <td>X {{ group.quantity }}</td>
      <td class="red_word">{{ group.price | jifen }}</td>
      <td class="user-order-operation red_word">
        {{ (group.price * group.quantity) | jifen }}
      </td>
    </tr> -->
    <tr>
      <td colspan="4" class="delivery" v-if="delivery_selected">
        <div v-if="!isDisplayTab">
          <div class="delivery-tit">
            <div class="express-info" v-if="delivery.factory_ship_text">
              配送服务:
              {{ getDeliveryInfo.factory_ship_text }}
            </div>
            <div class="express-info">
              物流公司:
              {{ delivery.express_name }}
            </div>
            <div class="express-info" v-if="delivery.express_number">
              物流单号:
              {{ delivery.express_number }}
              <span
                class="copy-btn"
                @click="copyOrderId"
                :data-clipboard-text="delivery.express_number"
                >复制</span
              >
            </div>
          </div>
          <ul class="timeline">
            <li
              class="timeline-item"
              v-for="(activity, i) in delivery.data &&
                delivery.data.slice().reverse()"
              :key="i"
            >
              <div
                class="right-line"
                v-show="i !== delivery.data.length - 1"
              ></div>
              <h4>
                <span>{{ activity.msgTime }}</span>
                <i
                  class="el-icon el-icon-mycircle"
                  :style="{ color: i === 0 ? '#FC0016' : '' }"
                ></i>
                <span>{{ activity.content }}</span>
              </h4>
            </li>
          </ul>
        </div>
        <el-tabs
          v-if="isDisplayTab"
          class="parcels"
          v-model="activeName"
          @tab-click="handleClick"
        >
          <el-tab-pane
            v-for="(val, index) in delivery.express_arr"
            :key="val"
            :label="`包裹${index + 1}`"
            :name="val"
          >
            <div class="delivery-tit">
              <div class="express-info" v-if="delivery.factory_ship_text">
                配送服务:
                {{ getDeliveryInfo.factory_ship_text }}
              </div>
              <div class="express-info">
                物流公司:
                {{ delivery.express_name }}
              </div>
              <div class="express-info" v-if="delivery.express_number">
                物流单号:
                {{ delivery.express_number }}
                <span
                  class="copy-btn"
                  @click="copyOrderId"
                  :data-clipboard-text="delivery.express_number"
                  >复制</span
                >
              </div>
            </div>
            <ul class="timeline">
              <li
                class="timeline-item"
                v-for="(activity, i) in delivery.data &&
                  delivery.data.slice().reverse()"
                :key="i"
              >
                <div
                  class="right-line"
                  v-show="i !== delivery.data.length - 1"
                ></div>
                <h4>
                  <span>{{ activity.msgTime }}</span>
                  <i
                    class="el-icon el-icon-mycircle"
                    :style="{ color: i === 0 ? '#FC0016' : '' }"
                  ></i>
                  <span>{{ activity.content }}</span>
                </h4>
              </li>
            </ul>
          </el-tab-pane>
        </el-tabs>
      </td>
    </tr>
    <tr v-if="msg_show">
      <td style="height: 32px;position: relative;">
        <div class="modeOfDistribution">
          <span>配送方式：默认配送</span>
          <span v-if="msg"
            >期望送达时间：
            <span>{{ msg.split(" ")[0] }}</span>
            <span style="color:#E64A3E">{{ msg.split(" ")[1] }}</span>
            <span>{{ msg.split(" ")[2] }}</span>
            <el-popover
              placement="bottom"
              width="200"
              trigger="click"
              content="期望送达时间为预估时间，仅供参考，具体请以实际送达时间为准。可能会因天气、交通、商家备货、订单先后顺序等各类因素影响造成延误或推迟，大件货物请注意接听配送人员电话预约送货时间。"
            >
              <i
                style="margin-left:20px"
                class="el-icon el-icon-hint"
                slot="reference"
                click
              ></i>
            </el-popover>
          </span>
        </div>
      </td>
    </tr>
  </tbody>
</template>
<script>
import eleImg from "@/assets/images/eleme.png";
import mtImg from "@/assets/images/meituan.png";
import Clipboard from "clipboard";
export default {
  props: {
    product: Object,
    orderInfo: Object,
    msg_show: Boolean,
    msg: String,
    code: String
  },
  data() {
    return {
      delivery: {},
      delivery_selected: false,
      activeName: ""
    };
  },
  computed: {
    isDisplayTab() {
      return this.delivery.express_arr && this.delivery.express_arr.length > 1;
    }
  },
  methods: {
    onFetch_getExpress(url) {
      this.$reqGet(url).then(res => {
        let data = res.data.data;
        this.delivery = data;
        this.delivery_selected = true;
        this.activeName = data.express_number;
      });
    },
    handleClick(tab) {
      this.activeName = tab._props.name;
      const url = `api/store/express/${this.product.id}?express_number=${
        tab._props.name
      }`;
      this.onFetch_getExpress(url);
    },
    getDeliveryInfo(product) {
      if (this.delivery.data) {
        this.delivery_selected = !this.delivery_selected;
        return;
      }
      const url = `api/store/express/${product.id}`;
      this.onFetch_getExpress(url);
    },
    gotoProduct(id) {
      this.$router.push({ name: "product-detail", query: { product_id: id } });
    },
    askServe(goods, supplier) {
      if (goods.complaint_display === false) {
        this.$confirm(
          "该商品您已申请过售后,如需再次申请,请联系在线客服申请售后",
          "提示",
          {
            confirmButtonText: "查看售后"
          }
        ).then(() => {
          this.$router.push({
            name: "refund-detail",
            params: { workorder_id: goods.workorder_id }
          });
        });
        return;
      }
      this.$reqGet("api/store/workorder/supportedservice/" + goods.id).then(
        res => {
          if (res.data.success) {
            if (
              !res.data.data.service_types ||
              res.data.data.service_types.length === 0
            ) {
              this.$confirm(
                "该商品已超过售后申请时效，可联系在线客服咨询",
                "提示",
                {
                  confirmButtonText: "联系客服"
                }
              ).then(() => {
                this.gotoCustomer();
              });
              return;
            }
            this.$router.push({
              name: "refund-submit",
              params: { product_id: goods.id },
              query: { supplier: supplier }
            });
          }
        }
      );
    },
    image(product) {
      return this.orderInfo.type != "7"
        ? this.orderInfo.type != "9"
          ? product.product_image
            ? product.product_image
            : this.goodsDefault
          : mtImg
        : eleImg;
    },
    copyOrderId() {
      var clipboard = new Clipboard(".copy-btn");
      clipboard.on("success", () => {
        clipboard.destroy();
      });
      this.$message({
        type: "success",
        message: "复制成功!"
      });
    }
  }
};
</script>
<style scoped lang="less">
.user-order-list {
  background-color: #fff;
  .modeOfDistribution {
    display: flex;
    // justify-content: space-between;
    font-size: 12px;
    color: #666666;
    line-height: 30px;
    position: absolute;
    left: 25px;
    top: 0;
    width: 850px;
    height: 32px;
    text-indent: 12px;
    background-color: #fbfbfb;
    & > span:nth-child(1) {
      margin-right: 32px;
    }
  }
  td {
    width: 188px;
    height: 105px;
    text-align: center;
    vertical-align: middle;
    box-sizing: border-box;
  }
  .user-order-name {
    width: 540px !important;
    box-sizing: border-box;
    padding-left: 40px;
    border-left: none;
    img {
      width: 60px;
      height: 60px;
      cursor: pointer;
    }
    .user-order-product-title {
      text-align: left;
      height: 57px;
      color: #222;
      // overflow: hidden;
      > div:first-child {
        display: -webkit-box;
        text-overflow: ellipsis;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        cursor: pointer;
        overflow: hidden;
      }
      > .type {
        color: #999999;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        width: 300px;
      }
      > .sku {
        color: #999999;
      }
    }
    .user-order-product-count {
      line-height: 57px;
      text-align: right;
      color: #999;
    }
  }
  .user-order-operation {
    padding-right: 40px;
    .refund {
      margin-top: 5px;
      font-size: 12px;
      color: #fc0010;
    }
  }
  .user-order-product-operate {
    > div {
      margin: 7px 0px 7px 10px;
      .el-button {
        width: 80px;
        height: 22px;
        line-height: 22px;
        padding: 0;
        color: #fff;
        background: rgba(226, 51, 63, 1);
        border-radius: 13px;
        border: none;
        font-size: 13px;
      }
    }
  }
  .title {
    > td {
      height: 30px;
      line-height: 30px;
      padding: 0px 15px;
      text-align: left !important;
      background: #fbfbfb;
    }
  }
  .group {
    background: #fbfbfb;
  }
  .after-price {
    > span {
      color: #e64a3e;
    }
  }
  .before-price {
    color: #999;
    text-decoration: line-through;
  }
}
.delivery {
  .parcels {
    /deep/ .el-tabs__nav-wrap {
      &::after {
        display: none;
      }
      .el-tabs__nav {
        .el-tabs__active-bar {
          display: none;
        }
        .el-tabs__item {
          padding: 0px 20px;
        }
        .el-tabs__item:hover {
          color: rgba(226, 51, 63, 1);
        }
        .el-tabs__item.is-active {
          color: #fff;
          background-color: rgba(226, 51, 63, 1);
        }
      }
    }
  }
  // height: 200px;
  background-color: #fbfbfb;

  .delivery-tit {
    padding: 0 20px;
    color: #000;
    line-height: 32px;
    border-bottom: 1px solid #e8e8e8;
    text-align: left !important;
    .express-info {
      display: inline-block;
      padding: 0 10px 0 0;
    }
  }
  .timeline {
    padding-left: 20px;
    text-align: left;
    .timeline-item {
      position: relative;
      h4 {
        font-weight: normal;
        span {
          display: inline-block;
        }
        i {
          margin-left: -1px;
        }
      }
    }
    .right-line {
      position: absolute;
      width: 1px;
      height: 20px;
      background: #ddd;
      left: 166px;
      top: 17px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/user/components/order-detail-product.vue